import { render, staticRenderFns } from "./LearningObjectiveViewer.vue?vue&type=template&id=66d4657f&scoped=true"
import script from "./LearningObjectiveViewer.vue?vue&type=script&lang=js"
export * from "./LearningObjectiveViewer.vue?vue&type=script&lang=js"
import style0 from "./LearningObjectiveViewer.vue?vue&type=style&index=0&id=66d4657f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4657f",
  null
  
)

export default component.exports